// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldCustomerAddress_labelContainer__I6NvD"};